import { FC } from 'react';
import { Link } from 'react-router-dom';
import GenericModal from '../../../shared/GenericModal/GenericModal';
import CustomAvatar from '../../../shared/CustomAvatar/CustomAvatar';
import { getInitials } from '../../../utils/functions';
import { AthleteListModalProps, AthleteListRow } from './AthleteListModal.types';
import styles from './AthleteListModal.module.scss';

const TONE_CLASS: Record<AthleteListRow['tone'], string> = {
  ok: styles.badgeOk,
  warn: styles.badgeWarn,
  alert: styles.badgeAlert,
};

/**
 * Modale condivisa: lista nomi atleti + valore-metrica + link al dettaglio.
 * Agganciata a due contatori KPI (stesso predicato del conteggio, derivato
 * lato chiamante da useTeamEffort/useTeamRecovery — nessun endpoint nuovo):
 * "Atleti fuori range" (Sforzo/ACWR) e "Atleti a rischio" (Recovery/RI).
 */
export const AthleteListModal: FC<AthleteListModalProps> = ({
  isOpen,
  onClose,
  title,
  emptyMessage = 'Nessun atleta da mostrare.',
  athletes,
}) => {
  return (
    <GenericModal isOpen={isOpen} onClose={onClose} title={title} size="md">
      <div className={styles.root}>
        {athletes.length === 0 ? (
          <p className={styles.empty}>{emptyMessage}</p>
        ) : (
          <ul className={styles.list}>
            {athletes.map((athlete) => (
              <li key={athlete.athleteId} className={styles.item}>
                <Link
                  to={`/dashboard/users/${athlete.athleteId}`}
                  className={styles.row}
                  onClick={onClose}
                >
                  <CustomAvatar name={getInitials(athlete.name)} className={styles.avatar} />
                  <div className={styles.info}>
                    <span className={styles.name}>{athlete.name}</span>
                    {athlete.role && <span className={styles.role}>{athlete.role}</span>}
                  </div>
                  <span className={`${styles.badge} ${TONE_CLASS[athlete.tone]}`}>
                    {athlete.metricValue}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </GenericModal>
  );
};

export default AthleteListModal;
